import 'jquery';

/**
 * submits form if checkbox is checked
 * only needs the attribute data-form="optional" on a form
 * has a hack to make it work even in broken form situations
 *
 */
(function ($) {

  let form = $('form[data-form="optional"]');

  if (!form.length) {
    return;
  }

  form.on('input', ':checkbox', function () {
    // on some pages our form is broken
    // thats why we add a hidden field to make it working
    // terrible hack
    form.find(':checked').each(function () {
      form.append('<input type="hidden" class="hidden" name="' + this.name + '" value="' + this.value + '" />');
    });
    form.submit();
  });

}(jQuery));
